import GlobalLabelFilters from "../../../../../global/GlobalLabelFilters";

const TREG_TIMING_ITEMS = [
  { key: "all", label: "All", variant: "all" },
  { key: "upcoming", label: "U Upcoming", variant: "upcoming" },
  { key: "closing_2d", label: "U Closing in 2 days", variant: "2d" },
  { key: "closing_1d", label: "U Closing in 1 day", variant: "1d" },
  { key: "ongoing", label: "O Ongoing (disabled)", variant: "ongoing" },
];

export default function TournamentRegistrationLabelFiltersSection({
  statusFilter,
  onFilterAll,
  onToggleFilter,
}) {
  return (
    <div className="treg-status-tools">
      <GlobalLabelFilters
        ariaLabel="Filter tournaments by registration status"
        items={TREG_TIMING_ITEMS}
        activeKey={statusFilter}
        onAll={onFilterAll}
        onToggle={onToggleFilter}
      />
    </div>
  );
}
